module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/jo-e678dae866ec74e6a939083ea4223eac.svg";